<template>
  <div class='bottom-buy-btn a-white a-fix-bottom a-ipx-bottom-border fx-row fx-c-center'>
    <div class='price-about'>
      <div class='a-text-36 a-text-bold a-text-center'>
        <span class='a-text-13 a-text-regular currency'>¥</span>{{info.price}}<span class='a-text-12 a-text-regular'>{{info.unit}}</span>
      </div>
    </div>
    <div class='a-text-20 a-text-bold' @click='handleBuy'>{{info.btn}}</div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true,
      default: () => {
        return {};
      }
    },
    bagNum: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleBuy() {
      if ( this.bagNum == 1 ) {
        // console.log('去收银台')
      } else {
        this.$emit('change-modal-status',{
          type: 'vip',
          value: true
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/_vars.scss";

.bottom-buy-btn {
  background-image: linear-gradient(-45deg, #1C1D1F 0%, #5C5E66 100%);
  height: 50 * $px;
  .price-about {
    width: 169 * $px;
    box-sizing: border-box;
    background: url('https://cdn.133.cn/gtgj/vipcard/btnBg.png') no-repeat center top;
    background-size: 100% 100%;
    margin-right: 36 * $px;
    .currency {
      display: inline-block;
      vertical-align: top;
      margin-top: 9 * $px;
    }
    &>div {
      width: 147 * $px;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/projects/vipCard/pages/home/components/home-buy-btn.vue